<template>
    <div
        class="apprentice-simple-card"
        id="portfolio-answers-spreadsheet">
        <design-2021-apprentice-data-table
            v-if="projectData.length"
            :fields="fields"
            :download-excel-settings="fields"
            :items="tableData"
            ref="apprentice-data-table"
            nosearch
            :hide-default-excel-button="true"
            :search-term="searchTermIn">
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice assignments">Er zijn geen opdrachten gevonden.</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-portfolio-answers-spreadsheet',
    props: {
        groupIn: Object,
        selectedOverviewIn: Number,
        searchTermIn: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            projectData: [],
        };
    },
    mounted() {
        this.getProjectData();
    },
    computed: {
        fields() {
            let fields = [
                {
                    key: 'title',
                    value: 'title',
                    name: 'Naam',
                    label: this.$t('common.name'),
                },
            ];
            if (this.projectData.length) {
                this.projectData[0].portfolio.categories
                    .sort((a, b) => a.order - b.order)
                    .forEach((category) => {
                        let categoryName = category.name + ' ';
                        category.assignments
                            .sort((a, b) => a.order - b.order)
                            .forEach((assignment) => {
                                let assignmentName = assignment.name + ' ';
                                assignment.sub_assignments
                                    .sort((a, b) => a.order - b.order)
                                    .forEach((subAssignment) => {
                                        let subAssignmentName = subAssignment.name + ' ';
                                        subAssignment.pages
                                            .sort((a, b) => a.order - b.order)
                                            .forEach((page) => {
                                                page.parts
                                                    .sort((a, b) => a.order - b.order)
                                                    .forEach((part) => {
                                                        let partName = part.name ?? '';
                                                        if ([1, 2, 3, 4, 7].includes(part.sub_type)) {
                                                            fields.push({
                                                                value: 'part_' + part.id,
                                                                key: 'part_' + part.id,
                                                                label:
                                                                    categoryName +
                                                                    assignmentName +
                                                                    subAssignmentName +
                                                                    partName,
                                                                name:
                                                                    categoryName +
                                                                    assignmentName +
                                                                    subAssignmentName +
                                                                    partName,
                                                            });
                                                        } else {
                                                            if (partName.length) {
                                                                partName = partName + ' ';
                                                            }

                                                            part.list_items.forEach((listItem) => {
                                                                fields.push({
                                                                    key: 'part_' + part.id + '_' + listItem.id,
                                                                    value: 'part_' + part.id + '_' + listItem.id,
                                                                    label:
                                                                        categoryName +
                                                                        assignmentName +
                                                                        subAssignmentName +
                                                                        ' ' +
                                                                        partName +
                                                                        ' ' +
                                                                        listItem.value,
                                                                    name:
                                                                        categoryName +
                                                                        assignmentName +
                                                                        subAssignmentName +
                                                                        ' ' +
                                                                        partName +
                                                                        ' ' +
                                                                        listItem.value,
                                                                });
                                                                partName = '';
                                                            });

                                                            part.list_checks;
                                                        }

                                                        partName = '';
                                                        categoryName = '';
                                                        assignmentName = '';
                                                        subAssignmentName = '';
                                                    });
                                            });
                                    });
                            });
                    });
            }
            return fields;
        },
        tableData() {
            return this.projectData.map((project) => {
                project.portfolio.categories.forEach((category) => {
                    category.assignments.forEach((assignment) => {
                        assignment.sub_assignments.forEach((subAssignment) => {
                            subAssignment.pages.forEach((page) => {
                                page.parts.forEach((part) => {
                                    if (part.answers.length) {
                                        switch (true) {
                                            case !!part.answers[0].text:
                                                project[`part_${part.id}`] = this.stripTags(part.answers[0].text.value);
                                                break;
                                            case !!part.answers[0].list_checks.length:
                                                project[`part_${part.id}`] = part.answers[0].list_checks
                                                    .map((listCheck) => { return listCheck.option_value ?? listCheck.item?.value })
                                                    .join(', ');
                                                break;
                                            case !!part.answers[0].list_items.length:
                                                part.answers[0].list_items.forEach((listItem) => {
                                                    let answer = listItem.option_value;
                                                    switch (listItem.option_value) {
                                                        case '#007bff':
                                                            answer = 'Blauw';
                                                            break;
                                                        case '#f35958':
                                                            answer = 'Rood';
                                                            break;
                                                        case '#ffb548':
                                                            answer = 'Oranje';
                                                            break;
                                                        case '#0acf97':
                                                            answer = 'Groen';
                                                            break;
                                                    }
                                                    project[`part_${part.id}_${listItem.item_id}`] = answer;
                                                });
                                                break;
                                            case part.answers[0].file_uploaded:
                                                project[`part_${part.id}`] = 'X';
                                                break;
                                            default:
                                                project[`part_${part.id}`] = '';
                                                break;
                                        }
                                    }
                                });
                            });
                        });
                    });
                });
                return project;
            });
        },
    },
    methods: {
        getProjectData() {
            this.axios.get(this.routes.getPortfolioAnswersForGroup(this.groupIn.id)).then(
                (response) => {
                    this.projectData = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        stripTags(input) {
            if (typeof input === 'string') {
                return input.replace(/<\/?[^>]+(>|$)/g, '');
            }

            return input;
        },

        // callDownloadExcel() {
        //     this.$refs['apprentice-data-table'].callDownloadExcel();
        // }
    },
    watch: {
        selectedOverviewIn: function () {
            this.getProjectData();
        },
    },
};
</script>

<style scoped lang="scss"></style>
